import { render } from "./ContactUs.vue?vue&type=template&id=7d085ec9"
import script from "./ContactUs.vue?vue&type=script&lang=js"
export * from "./ContactUs.vue?vue&type=script&lang=js"
script.render = render

export default script